import React from "react";

function Terms() {
  return (
    <div className="container">
      <div className="row mt-2">
        <div className="poppins-black mt-2">1. Introduction</div>
        <div className="poppins-regular mt-1">
          1.1 These terms and conditions shall govern your use of our website
          ProLeverage.io
        </div>
        <div className="poppins-regular mt-1">
          1.2 By using our website, you accept these terms and conditions in
          full; accordingly, if you disagree with these terms and conditions or
          any part of these terms and conditions, you must not use our website.
        </div>
        <div className="poppins-regular mt-1">
          1.3 If you [register with our website, submit any material to our
          website or use any of our website services], we will ask you to
          expressly agree to these terms and conditions.
        </div>
        <div className="poppins-regular mt-1">
          1.4 You must be at least [18] years of age to use our website; and by
          using our website or agreeing to these terms and conditions, you
          warrant and represent to us that you are at least [18] years of age.
        </div>
        <div className="poppins-regular mt-1">
          1.5 Our website uses cookies; by using our website or agreeing to
          these terms and conditions, you consent to our use of cookies in
          accordance with the terms of our [privacy and cookies policy].
        </div>

        <div className="poppins-black mt-2">
          2. You wont distribute any content of our site without our permission.
        </div>
        <div className="poppins-regular mt-1">
          2.1 ProLeverage is exclusively designed for its subscribers only and
          you are not allowed to publish or distribute any of ProLeverage
          content on any platform without our written permission.
        </div>

        <div className="poppins-black mt-2">3. Copyright notice</div>
        <div className="poppins-regular mt-1">
          3.1 Copyright (c) 2024 by ProLeverage Pvt Ltd & Ronald C mat.
        </div>
        <div className="poppins-regular mt-1">
          3.2 Subject to the express provisions of these terms and conditions:
        </div>
        <div className="poppins-regular mt-1">
          (a) we, together with our licensors, own and control all the copyright
          and other intellectual property rights in our website and the material
          on our website; and
        </div>
        <div className="poppins-regular mt-1">
          (b) all the copyright and other intellectual property rights in our
          website and the material on our website are reserved.
        </div>

        <div className="poppins-black mt-2">4. Licence to use website</div>
        <div className="poppins-regular mt-1">4.1 You may:</div>
        <div className="poppins-regular mt-1">
          (a) view pages from our website in a web browser;
        </div>
        <div className="poppins-regular mt-1">
          (b) download pages from our website for caching in a web browser;
        </div>
        <div className="poppins-regular mt-1">
          (c) print pages from our website;
        </div>
        <div className="poppins-regular mt-1">
          (d) stream audio and video files from our website; and
        </div>
        <div className="poppins-regular mt-2">
          subject to the other provisions of these terms and conditions.
        </div>
        <div className="poppins-regular mt-1">
          4.2 Except as expressly permitted by Section 4.1 or the other
          provisions of these terms and conditions, you must not download any
          material from our website or save any such material to your computer.
        </div>
        <div className="poppins-regular mt-1">
          4.3 You may only use our website for [your own personal and business
          purposes], and you must not use our website for any other purposes.
        </div>
        <div className="poppins-regular mt-1">
          4.4 Except as expressly permitted by these terms and conditions, you
          must not edit or otherwise modify any material on our website.
        </div>
        <div className="poppins-regular mt-1">
          4.5 Unless you own or control the relevant rights in the material, you
          must not:
        </div>
        <div className="poppins-regular mt-1">
          (a) republish material from our website (including republication on
          another website);
        </div>
        <div className="poppins-regular mt-1">
          (b) sell, rent or sub-license material from our website;
        </div>
        <div className="poppins-regular mt-1">
          (c) show any material from our website in public;
        </div>
        <div className="poppins-regular mt-1">
          (d) exploit material from our website for a commercial purpose; or
        </div>
        <div className="poppins-regular mt-1">
          (e) redistribute material from our website.
        </div>
        <div className="poppins-regular mt-1">
          4.6 Notwithstanding Section 4.5, you may redistribute [our newsletter]
          in [print and electronic form] to [any person].
        </div>
        <div className="poppins-regular mt-1">
          4.7 We reserve the right to restrict access to areas of our website,
          or indeed our whole website, at our discretion; you must not
          circumvent or bypass, or attempt to circumvent or bypass, any access
          restriction measures on our website.
        </div>

        <div className="poppins-black mt-2">5. Acceptable use</div>
        <div className="poppins-regular mt-1">5.1 You must not:</div>
        <div className="poppins-regular mt-1">
          (a) use our website in any way or take any action that causes, or may
          cause, damage to the website or impairment of the performance,
          availability or accessibility of the website;
        </div>
        <div className="poppins-regular mt-1">
          (b) use our website in any way that is unlawful, illegal, fraudulent
          or harmful, or in connection with any unlawful, illegal, fraudulent or
          harmful purpose or activity;
        </div>
        <div className="poppins-regular mt-1">
          (c) use our website to copy, store, host, transmit, send, use, publish
          or distribute any material which consists of (or is linked to) any
          spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit
          or other malicious computer software;
        </div>
        <div className="poppins-regular mt-1">
          (d) conduct any systematic or automated data collection activities
          (including without limitation scraping, data mining, data extraction
          and data harvesting) on or in relation to our website without our
          express written consent;
        </div>
        <div className="poppins-regular mt-2">
          (e) [access or otherwise interact with our website using any robot,
          spider or other automated means;]
        </div>
        <div className="poppins-regular mt-1">
          (f) [violate the directives set out in the robots.txt file for our
          website; or]
        </div>
        <div className="poppins-regular mt-1">
          (g) [use data collected from our website for any direct marketing
          activity (including without limitation email marketing, SMS marketing,
          telemarketing and direct mailing).]
        </div>
        <div className="poppins-regular mt-1">
          5.2 You must not use data collected from our website to contact
          individuals, companies or other persons or entities.
        </div>
        <div className="poppins-regular mt-1">
          5.3 You must ensure that all the information you supply to us through
          our website, or in relation to our website, is [true, accurate,
          current, complete and non-misleading].
        </div>

        <div className="poppins-black mt-2">6. Registration and accounts</div>
        <div className="poppins-regular mt-1">
          6.1 To be eligible for an individual account on our website under this
          Section 6, you must [be at least 18 years of age and resident in
          India].
        </div>
        <div className="poppins-regular mt-1">
          6.2 You may register for an account with our website by [completing
          and submitting the account registration form on our website, and
          clicking on the verification link in the email that the website will
          send to you].
        </div>
        <div className="poppins-regular mt-1">
          6.3 You must not allow any other person to use your account to access
          the website.
        </div>
        <div className="poppins-regular mt-1">
          6.4 You must notify us in writing immediately if you become aware of
          any unauthorised use of your account.
        </div>
        <div className="poppins-regular mt-1">
          6.5 You must not use any other person’s account to access the
          website[, unless you have that person’s express permission to do so].
        </div>

        <div className="poppins-black mt-2">7. User IDs and passwords</div>
        <div className="poppins-regular mt-1">
          7.1 If you register for an account with our website, [we will provide
          you with / you will be asked to choose] a user ID and password.
        </div>
        <div className="poppins-regular mt-1">
          7.2 Your user ID must not be liable to mislead and must comply with
          the content rules set out in Section 10; you must not use your account
          or user ID for or in connection with the impersonation of any person.
        </div>
        <div className="poppins-regular mt-1">
          7.3 You must keep your password confidential.
        </div>
        <div className="poppins-regular mt-1">
          7.4 You must notify us in writing immediately if you become aware of
          any disclosure of your password.
        </div>
        <div className="poppins-regular mt-1">
          7.5 You are responsible for any activity on our website arising out of
          any failure to keep your password confidential, and may be held liable
          for any losses arising out of such a failure.
        </div>
      </div>
    </div>
  );
}
export default Terms;
